import { render, staticRenderFns } from "./bottom-navigation.vue?vue&type=template&id=425accd4&scoped=true&"
import script from "./bottom-navigation.vue?vue&type=script&lang=ts&"
export * from "./bottom-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./bottom-navigation.vue?vue&type=style&index=0&id=425accd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425accd4",
  null
  
)

export default component.exports